/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiSalesWeb } from '@shared/config';

export interface IGetCustomerCard {
  id: string;
  externalId: string;
  customerId: string;
  cardToken: string;
  firstSixNumbers: string;
  lastFourNumbers: string;
  brand: string;
  expirationMonth: string;
  expirationYear: string;
  confirmationNumber: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export async function getCustomerCard(companyId: string) {
  return apiSalesWeb.get<IGetCustomerCard[]>(`/customer-card/${companyId}`);
}
